import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { PressureFilters, ContentSection } from '~/components';
import ContentData from '~/hoc/ContentData';
import { Pressure as PressureAction } from '~/actions';
import moment from '~/_moment';

const ReactHichart = require('react-highcharts');
require('highcharts-drilldown')(ReactHichart.Highcharts);

class Rain extends Component {
  state = {
    requestTime: moment().format('YYYY-MM-DD'),
  };

  UNSAFE_componentWillMount() {
    const {
      match: {
        params: { time },
      },
    } = this.props;
    if (time) {
      this.setState({ requestTime: time });
    }

    this.intialData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      match: {
        params: { time: prevTime },
      },
    } = this.props;
    const {
      match: {
        params: { time: nextTime },
      },
    } = nextProps;

    if (prevTime !== nextTime) {
      this.intialData(nextProps);
    }
  }

  intialData = (props) => {
    const {
      loadPressure,
      match: {
        params: { time },
      },
    } = props;
    const requestTime = time || moment().format('YYYY-MM-DD');
    loadPressure(requestTime);
  };

  processRainData = ({ data }) => {
    const rainSlot = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ];
    const drilldownSlot = [];

    // find max rain of each hr
    const totalRainHour = data.reduce((result, { time, rain }) => {
      const match = time.match(/([0-9]{2}):([0-9]{2}):[0-9]{2}$/);

      const hr = Number(match[1]);
      const minIndex = Number(match[2]);

      const timeIndex = minIndex === 0 ? hr - 1 : hr;

      if (timeIndex >= 0) {
        const currentRain = Number(rain);

        const timeLabelHr = moment(3600000 * timeIndex)
          .utcOffset(0)
          .format('HH:mm');

        if (!result[timeIndex].y) {
          result[timeIndex] = {
            name: `${timeLabelHr} - ${moment(3600000 * timeIndex)
              .utcOffset(0)
              .format('HH:59')}`,
            y: 0,
            drilldown: timeLabelHr,
          };

          drilldownSlot[timeIndex] = {
            name: `ปริมาณน้ำฝนราย 15 นาทีของชั่วโมงที่ ${timeLabelHr}`,
            id: timeLabelHr,
            data: [
              [`ชั่วโมงที่ ${timeIndex} นาที 00 - 15`, 0],
              [`ชั่วโมงที่ ${timeIndex} นาที 15 - 30`, 0],
              [`ชั่วโมงที่ ${timeIndex} นาที 30 - 45`, 0],
              [`ชั่วโมงที่ ${timeIndex} นาที 45 - 00`, 0],
            ],
          };
        }

        result[timeIndex].y += currentRain;

        let section = 3;

        if (minIndex > 0 && minIndex <= 15) {
          section = 0;
        } else if (minIndex > 15 && minIndex <= 30) {
          section = 1;
        } else if (minIndex > 30 && minIndex <= 45) {
          section = 2;
        }

        drilldownSlot[timeIndex].data[section][1] += currentRain;
      }

      return result;
    }, rainSlot);

    return { totalRainHour, drilldownSlot };
  };

  chartConfig = (dataInput, drilldownSlot, siteName, date) => ({
    chart: {
      type: 'column',
    },
    title: {
      text: `กราฟแสดงปริมาณน้ำฝน ${date}`,
    },
    subtitle: {
      text: 'ปริมาณน้ำฝน (มม.)',
    },
    xAxis: {
      typs: 'category',
    },
    yAxis: {
      min: 0,
      units: [['มม.', null]],
      title: 'มม.',
    },
    series: [
      {
        name: siteName,
        data: dataInput,
      },
    ],
    drilldown: {
      series: drilldownSlot,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}',
        },
      },
    },
  });

  loadRainData = () => {
    const { pressure, history } = this.props;
    history.push(`/rain/history/${pressure.date}`);
  };

  handleChangeDate = (date) => {
    this.setState(
      {
        requestTime: date,
      },
      () => {
        this.props.handleChangeDate(date);
      },
    );
  };

  render() {
    const { isLoading, rainData, profile, pressure } = this.props;

    const processedData = rainData.data && this.processRainData(rainData);
    const config =
      processedData &&
      processedData.totalRainHour &&
      this.chartConfig(
        processedData.totalRainHour,
        processedData.drilldownSlot,
        profile.site_name,
        moment(rainData.date).format('DD MMMM YYYY'),
      );

    return (
      <ContentSection>
        <Helmet>
          <title>ระบบประมวลผลปริมาณน้ำฝน</title>
        </Helmet>
        <ContentData title="ประมวลผลปริมาณน้ำฝน" isLoading={!config || isLoading}>
          <PressureFilters
            siteName={profile.site_name}
            dateFormat="YYYY-MM-DD"
            timeFormat="HH:mm"
            dateValue={this.state.requestTime}
            showTimePicker={false}
            isPressureloading={pressure.isloading}
            handleLoadData={() => this.loadRainData()}
            handleChangeDate={this.handleChangeDate}
            disabledDate={moment(profile.firstRun).subtract(1, 'days')}
          />
          {config && <ReactHichart config={config} />}
        </ContentData>
      </ContentSection>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      rainData: state.Rain,
      profile: state.DamProfile,
      pressure: state.Pressure,
    }),
    {
      loadPressure: PressureAction.loadPressureData,
      handleChangeDate: PressureAction.changeDate,
    },
  )(Rain),
);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Rain/index.js